export enum OPTION_KEYS_FOR_SELECT {
  All = 'all',
}

export enum MEASUREMENT_VALIDITY {
  WithErrors = 'withErrors',
  WithoutErrors = 'withoutErrors',
}
